import store from '@/store'
// import api from '@/lib/api'

export const requiresAdmin = (to, _from, next) => {
  if ( !store.getters['auth/userIsAdmin'] ) {
    next({ path: '/home' })
  } else  {
    next()    
  }
}

export const requiresAuth = (to, _from, next) => {
  const isLoggedIn = store.getters['auth/signedIn']   
  if ( !isLoggedIn ) {
    next({ path: '/login' })
  } else  {
    next()    
  }
}

export const logout = (_to, _from, next) => {
  // api.insecure_post('/users/logout').then( () => {
  //   store.commit('auth/LOGOUT')
  //   next({ name: 'login' })  
  // })

  store.commit('auth/LOGOUT')
  next({ name: 'login' })  
}
